import { render, staticRenderFns } from "./UnpairIcon.vue?vue&type=template&id=02ca4a5f"
import script from "./UnpairIcon.vue?vue&type=script&lang=ts"
export * from "./UnpairIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports